import type { Institution } from '../types/identity'

export const institutions: Institution[] = [
  {
    id: 'inst-unilag',
    name: 'University of Lagos',
    shortName: 'UNILAG',
    place: { country: 'Nigeria', state: 'Lagos', city: 'Lagos' },
    integrationLevel: 'directory',
    campuses: [
      {
        id: 'campus-akoka',
        name: 'Akoka Main Campus',
        neighbourhood: 'Akoka',
        lat: 6.5158,
        lng: 3.3898,
      },
      {
        id: 'campus-idi-araba',
        name: 'Idi-Araba College of Medicine',
        neighbourhood: 'Surulere',
        lat: 6.5108,
        lng: 3.3479,
      },
    ],
  },
  {
    id: 'inst-oau',
    name: 'Obafemi Awolowo University',
    shortName: 'OAU',
    place: { country: 'Nigeria', state: 'Osun', city: 'Ile-Ife' },
    integrationLevel: 'none',
    campuses: [
      {
        id: 'campus-ife',
        name: 'Ile-Ife Main Campus',
        neighbourhood: 'Ibadan Road',
        lat: 7.5188,
        lng: 4.5286,
      },
    ],
  },
  {
    id: 'inst-abu',
    name: 'Ahmadu Bello University',
    shortName: 'ABU',
    place: { country: 'Nigeria', state: 'Kaduna', city: 'Zaria' },
    integrationLevel: 'full',
    campuses: [
      {
        id: 'campus-samaru',
        name: 'Samaru Campus',
        neighbourhood: 'Samaru',
        lat: 11.1533,
        lng: 7.6486,
      },
    ],
  },
]

export const campusOptions = institutions.flatMap((institution) =>
  institution.campuses.map((campus) => ({
    id: campus.id,
    label: `${institution.shortName} — ${campus.name}`,
    institutionId: institution.id,
  })),
)

export function institutionById(id: string): Institution | undefined {
  return institutions.find((institution) => institution.id === id)
}

export function campusById(id: string) {
  for (const institution of institutions) {
    const campus = institution.campuses.find((item) => item.id === id)
    if (campus) return { institution, campus }
  }
  return undefined
}
